<template>
    <div class="first_header_mian">
        <div class="text_on">
            <slot name="title"> </slot>
            <!-- {{ props.title }} -->
        </div>
        <div class="chaicon" @click="Shutdown">
            <img src="../../assets/Homeimg/clonse.webp" alt="" />
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, defineProps } from 'vue'
const emit = defineEmits(["getValue"])
const props = defineProps({
    title: {
        type: String,
    },
})
const Shutdown = () => {
    emit("getValue", false)
}
</script>
<style  lang="less" scoped>
.first_header_mian {
    width: 100%;
    height: 91px;
    // background: wheat;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text_on {
        min-width: 158px;
        height: 20px;
        color: white;
        font-size: 18px;
        font-weight: bold;
    }
    .chaicon {
        width: 18px;
        height: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition-duration: 0.2s;

        img {
            width: 18px;
            height: 18px;
        }
    }
    .chaicon:hover{
        opacity: 0.7;
    }
    .chaicon:active{
        transform: scale(0.9);
    }
}</style>